import * as React from 'react';

import { CompanyIdContext } from './CompanyContext';

export const useCompanyId = () => {
  const context = React.useContext(CompanyIdContext);

  if (context === null) {
    throw new Error(
      'useCompanyId can only be used with a <CompanyIdProvider/> or a <CompanyIdFromRouteProvider />'
    );
  }

  return {
    companyId: context.id,
  };
};
